export const logo = process.env.REACT_APP_THEME_LOGO;

export default logo;
